<template>
  <div class="home">
    <div class="menu">
      <b-navbar toggleable="lg">
        <b-navbar-brand href="#"><img src="../assets/img/img_logo.svg" alt=""></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav>
              <b-nav-item href="#contacto">QUIERO VENDER MI CASA</b-nav-item>
            </b-navbar-nav>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div class="banner">
        <b-container>
          <b-row>
            <b-col md="6" class="vcenter text-banner">
              <h1>
                Vende tu casa en un ambiente de confianza y transparencia.
              </h1>
              <p>
                Nuestra orientación logrará que tu objetivo de vender sea más ligero y sin contratiempos.
              </p>
            </b-col>
            <b-col md="6" class="vcenter">
              <img class="img-fluid" src="../assets/img/img1.jpg" alt="">
            </b-col>
          </b-row>
        </b-container>
    </div>
    <div class="segment1">
      <b-container fluid>
        <b-row>
          <b-col>
            <img class="img-fluid" src="../assets/img/img2.jpg" alt="">
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="segment2">
      <b-container>
        <b-row>
          <b-col md="8">
              <p>Recompensa tu esfuerzo a través de la plusvalía de tu casa, en <b>Terralty®</b> te acompañaremos en un proceso transparente y conveniente para ti.</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <img class="img-fluid mb-3" src="../assets/img/img3.jpg" alt="">
          </b-col>
          <b-col>
            <img class="img-fluid mb-3" src="../assets/img/img4.jpg" alt="">
          </b-col>
          <b-col>
            <img class="img-fluid mb-3" src="../assets/img/img5.jpg" alt="">
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div id="contacto" class="contact">
        <b-container>
          <b-row class="mb-5">
            <b-col md="10">
              <h1>Compártenos tus datos y rápidamente nos comunicaremos contigo.</h1>
              <p>Nos comprometemos a resguardar tus datos en un lugar seguro y utilizarlos únicamente para ayudarte en tu proceso de venta.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-alert v-if="messageError" show variant="danger">{{messageError}}</b-alert>
            <b-col md="6" class="mb-4">
              <label for="">Nombre</label>
              <b-form-input v-model="name" placeholder="Ingresa tu nombre y apellido"></b-form-input>
            </b-col>
            <b-col md="6" class="mb-4">
              <label for="">Teléfono</label>
              <b-form-input v-model="phone" placeholder="Ingresa un número de teléfono para contactarte"></b-form-input>
            </b-col>
            <b-col md="6" class="mb-4">
              <label for="">Correo electrónico</label>
              <b-form-input v-model="email" placeholder="Ingresa tu correo electrónico"></b-form-input>
            </b-col>
            <b-col md="6" class="mb-4">
              <label for="">Colonia o fraccionamiento</label>
              <b-form-input v-model="address1" placeholder="Compártenos la colonia o fraccionamiento"></b-form-input>
            </b-col>
            <b-col md="6" class="mb-4">
              <label for="">Calle y número</label>
              <b-form-input v-model="address2" placeholder="Compártenos calle y número de tu propiedad"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="mb-4">
              <b-button v-on:click="sendMessage"> Enviar mis datos</b-button>
            </b-col>
          </b-row>
        </b-container>
    </div>
    <div class="footer text-center">
      <b-container>
        <b-row>
          <b-col>
            <img class="logo" src="../assets/img/img_logo_white.svg" alt="">
            <p>(686) 262 4037</p>
            <p>Calz. Cetys 2681 Local 5, Marsella, 21225 Mexicali, B.C.</p>
            <p><a href="#">Aviso de privacidad</a></p>
            <!-- <p><a href=""><img class="icon-social" src="../assets/img/icn_facebook.svg" alt=""></a> <a href=""><img class="icon-social" src="../assets/img/icn_instagram.svg" alt=""></a> </p> -->
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal id="modal-center" centered hide-footer hide-header>
        <div class="text-center modal-wrapper">
            <img class="img-modal" src="../assets/img/icn_confirmation.svg" alt="">
            <p class="title-modal">Tu mensaje ha sido enviado</p>
            <p class="text-modal">Nos pondremos en contacto contigo lo mas pronto posible.</p>
        </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Home',
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      address1: '',
      address2: '',
      messageError: ''
    }
  },
  props: {
  },
  methods: {
    async sendMessage() {
      this.messageError = ''
      if(this.name && this.email && this.phone && this.address1 && this.address2){
        var responseData = ''
        await axios.post('/vendor/send-mail.php', {
          name: this.name,
          email: this.email,
          phone: this.phone,
          address1:  this.address1,
          address2:  this.address2
        })
        .then((response) => {
          console.log(response)
          responseData = response.data
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
        
        if(responseData==200 || responseData=='200') {
          this.name = ''
          this.email = ''
          this.phone = ''
          this.address1 = ''
          this.address2 = ''
          this.$bvModal.show('modal-center')
        }
      } else {
        this.messageError = 'Es necesario ingresar todos los valores'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1{
  font-family: 'Noto Serif JP', serif;
  font-size: 42px;
}
ul{
  list-style-type: none;
  padding: 0;
}
li{
  display: inline-block;
  margin: 0 10px;
}
a{
  text-decoration: none;
}
.ml-auto{
  margin-left: auto;
}
.mr-auto{
  margin-right: auto;
}

/* NAVBAR */
.menu{
  width: 100%;
  position: fixed;
  background: #fff;
}
.navbar{
  padding: 20px 5%;
}

/* BANNER */
.banner{
  padding-top: 150px 
}
.banner h1{
  margin-bottom: 10px;
}
.banner p{
  font-weight: 300;
  font-size: 25px;
}
.text-banner{
  padding-left: 8%;
  padding-right: 5%;
}

/* SEGMENT 1 */
.segment1 .container-fluid{
  margin-top: 170px;
  max-width: 1359px;
}

/* SEGMENT 2 */
.segment2 .container{
  margin-top: 170px;
  max-width: 1044px;
}
.segment2 p{
  font-size: 25px;
  margin-bottom: 30px;
  font-weight: 300;
}

/* FORM */
.contact {
  margin-top: 150px;
}
.contact .container{
  max-width: 1044px;
}
.contact p{
  font-size: 25px;
  font-weight: 300;
}
.form-control{
  border: 1px solid #000;
  border-radius: 0px;
  font-size: 13px;
  padding: 8px 12px;
}
label{
  font-size: 15px;
}
.btn{
  border: 1px solid #000;
  background: #000;
  color: #fff;
  border-radius: 0;
  width: 100%;
  font-family: 'Noto Serif JP', serif;
  font-size: 18px;
  font-weight: 500 !important;
}

/* FOOTER */
.footer{
  margin-top: 190px;
  background: #000;
  color: #fff;
  padding: 50px 10% 70px;
}
.footer p{
  margin-bottom: 0;
  font-size: 16px;
}
.footer a{
  color: #fff;
}
.footer .logo{
  margin-bottom: 15px;
}
.icon-social{
  margin: 10px;
}

/* MODAL */
.modal-wrapper{
    padding: 100px 10px;
}
.img-modal{
    margin-bottom: 28px;
}
.title-modal{
    margin-bottom: 0;
    font-family: 'Noto Serif JP', serif;
    font-weight: 400;
    font-size: 35px;
}
.text-modal{
    margin-bottom: 0;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 20px;
    margin: auto;
    width: 70%;
}

@media (max-width: 768px){
  h1{
    font-size: 35px;
  }

  .banner,
  .segment1 ,
  .segment2,
  .contact {
    padding-left: 25px;
    padding-right: 25px;
  }
  .banner p{
    font-size: 20px;
  }
  .text-banner{
    padding-left: 12px;
    padding-right: 12px;
  }

  /* SEGMENT 1 */
  .segment1 .container-fluid{
    margin-top: 100px;
  }

  /* SEGMENT 2 */
  .segment2 .container{
    margin-top: 100px;
    max-width: 1044px;
  }
  .segment2 p{
    font-size: 20px;
  }

  /* FORM */
  .contact {
    margin-top: 100px;
  }
  .contact .container{
    max-width: 1044px;
  }
  .contact p{
    font-size: 20px;
  }

  /* FOOTER */
  .footer{
    margin-top: 100px;
  }
  

  /* MODAL */
  .modal-wrapper{
      padding: 100px 10px;
  }
  .img-modal{
      margin-bottom: 28px;
  }
  .title-modal{
      font-size: 25px;
  }
  .text-modal{
      font-size: 18px;
      width: 100%;
  }

}

</style>
